/**
 * Validate that a returnUrl-style query parameter is safe to feed into router.navigateByUrl.
 *
 * Only same-origin absolute paths are allowed. Protocol-relative URLs ("//evil.com/...") and
 * backslash-prefixed paths ("/\evil.com") are rejected because some browsers normalise them into
 * cross-origin navigations.
 */
export const isSafeReturnUrl = (value: unknown): value is string => {
    if (typeof value !== "string" || value.length === 0) return false
    if (!value.startsWith("/")) return false
    if (value.startsWith("//")) return false
    if (value.startsWith("/\\")) return false
    return true
}
